var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "hx-breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { "separator-class": "el-icon-arrow-right" } },
            [
              _c("el-breadcrumb-item", [_vm._v("疗养预约系统")]),
              _c("el-breadcrumb-item", [_vm._v("公告信息")]),
              _c("el-breadcrumb-item", [_vm._v("公告信息详情")]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "hx-form-container box-shadow",
          staticStyle: { width: "800px", "margin-top": "40px" },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.formLoading,
                  expression: "formLoading",
                },
              ],
              attrs: { rules: _vm.checkItemParams, model: _vm.listParams },
            },
            [
              _c("el-form-item", { attrs: { label: "公告标题：" } }, [
                _vm._v(" " + _vm._s(_vm.listParams.title) + " "),
              ]),
              _c("el-form-item", { attrs: { label: "公告内容：" } }, [
                _c("div", {
                  domProps: { innerHTML: _vm._s(_vm.listParams.content) },
                }),
              ]),
              _c("el-form-item", { attrs: { label: "发布时间：" } }, [
                _vm._v(" " + _vm._s(_vm.listParams.publishTime) + " "),
              ]),
              _c(
                "el-form-item",
                { staticStyle: { "padding-bottom": "30px" } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: {
                        left: "50%",
                        "margin-left": "-28px",
                        position: "absolute",
                      },
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.dialogVisible = true
                        },
                      },
                    },
                    [_vm._v(" 删除 ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            visible: _vm.dialogVisible,
            width: "30%",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("span", [_vm._v("确定要删除该公告吗")]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  staticStyle: { background: "crimson", border: "none" },
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.deleteItem()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }